'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import ErrorPage from '@/components/ErrorPage';

// This replaces the root layout, so it must render its own <html>/<body> — it is the only error
// boundary allowed to do so. Unlike app/error.tsx it also has no next-intl/domain-theming
// providers above it, so ErrorPage falls back to bilingual copy and plain theme colors.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Log the error to Sentry
        Sentry.captureException(error);
    }, [error]);

    return (
        <html lang="de">
            <body>
                <ErrorPage onReset={reset} />
            </body>
        </html>
    );
}
